import React, { useState } from "react";
import styled from "styled-components/macro";
import step0_1 from "../../../images/unit/wizard/step0_1.svg";
import step0_2 from "../../../images/unit/wizard/step0_2.svg";
import step0_3 from "../../../images/unit/wizard/step0_3.svg";
import { useForm } from "react-hook-form";
import edit from "../../../images/unit/wizard/edit.svg";
import { StyledBlackButton } from "../../ButtonsStyle";
import CityComplete from "../CItyAutoComplete/CityComplete";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import dropdown from "../../../images/dropdown.png";

const WizardUnitStep1 = ({
  roll,
  setRoll,
  email,
  name,
  onClick,
  ipDetails,
  onChangeCity,
  city,
  onChangeEmail,
  onChangeName,
}) => {
  const { register } = useForm();
  const [show, setShow] = useState(false);

  const classes = useStyles();

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const validation = () => {
    if (email !== "") {
      const pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      return pattern.test(email.trim());
    }
    return false;
  };

  const isDisabled = !validation() || name === "" || roll === "null";

  return (
    <Wrapper>
      <Title style={{ marginBottom: "30px" }} fontSize={45}>
        Create Your TULU
      </Title>
      <ImagesWrapper>
        <Section>
          <Title fontSize={20}>
            {"1\nAnswer a few questions\nabout your property"}
          </Title>
          <img src={step0_1} alt={"step0_1"} />
        </Section>
        <Section>
          <Title fontSize={20}>{"2\nGet a custom\nunit"}</Title>
          <img src={step0_2} alt={"step0_2"} />
        </Section>
        <Section>
          <Title fontSize={20}>
            {"3\nWe’ll prepare the agreement\nand ship your unit"}
          </Title>
          <img src={step0_3} alt={"step0_3"} />
        </Section>
      </ImagesWrapper>
      <GreyArea>
        <Title fontSize={25}>
          {"Before we start, Please leave us your details:"}
        </Title>

        <InputSection>
          <InputWrapper>
            <Input
              defaultValue={name}
              validation
              type="text"
              placeholder="Your Name"
              name="Name"
              onChange={(event) => onChangeName(event.target.value)}
              ref={register({ required: true, maxLength: 80 })}
            />
          </InputWrapper>
          <InputWrapper>
            <Select
              style={{ color: roll === "null" ? "darkgrey" : "#707070" }}
              defaultValue={roll}
              onChange={(event) => setRoll(event.target.value)}
              img={dropdown}
              name="Your Role"
              ref={register({ required: true })}
            >
              <option value="null" defaultValue="selected">
                Your Role
              </option>
              <option style={{ color: "#2D5566" }} value="owner">
                Owner
              </option>
              <option value="propertyManager">Property Manager</option>
              <option value="tenant">Tenant</option>
              <option value="businessOwner">Business Owner</option>
              <option value="other">Other</option>
            </Select>
          </InputWrapper>
        </InputSection>
        <Input
          style={{ width: "480px", marginBottom: "20px" }}
          defaultValue={email}
          validation={email === "" || validation()}
          type="text"
          placeholder="Your@email.com"
          name="Email"
          onChange={(event) => onChangeEmail(event.target.value)}
          ref={register({ required: true })}
        />
        <InputWrapper>
          <CityContainer onClick={handleShow}>
            <Title
              color={"#707070"}
              style={{
                margin: "0",
                fontFamily: "Manrope,serif",
                textAlign: "start",
              }}
              fontSize={16}
            >
              {city
                ? city.formatted_address
                : ipDetails
                ? `${ipDetails.city}`
                : " "}
            </Title>
            <div style={{ display: "flex", position: "relative" }}>
              <div style={{ margin: "0 10px" }}>Edit location</div>
              <img src={edit} alt={"edit"} />
            </div>
          </CityContainer>
        </InputWrapper>
        <div style={{ height: "25px" }} />
        <StyledBlackButton
          disabled={isDisabled}
          onClick={onClick}
          style={{
            backgroundColor: "#606060",
            opacity: isDisabled ? 0.4 : 1,
            color: "#FFFFFF",
            fontSize: "20px",
            fontFamily: "Manrope,serif",
            padding: "10px 40px",
          }}
        >
          Let's Go!
        </StyledBlackButton>
      </GreyArea>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={show}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <>
          <ModalWrapper>
            <CityComplete
              onChange={(newCity) => {
                handleClose();
                onChangeCity(newCity);
              }}
            />
          </ModalWrapper>
        </>
      </Modal>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;
`;

const InputWrapper = styled.div`
  margin: 0 7px;
`;
const ModalWrapper = styled.div`
  width: 50vw;
  height: 50vh;
  border-radius: 20px;
  background-color: white;
  padding: 20px 30px;
`;
const CityContainer = styled.div`
  color: #707070;
  padding: 10px;
  width: 480px;
  border: 1px solid #dcdcdc;
  background-color: white;
  display: flex;
  margin: 0;
  cursor: pointer;
  opacity: ${({ opacity }) => opacity};
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
`;
const Select = styled.select`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  width: 233px;
  background: white url(${({ img }) => img}) no-repeat 95% 50%;
  background-size: 15px;
  color: #707070;
  padding: 10px;
  font-family: Manrope, serif;
  border: 1px solid #dcdcdc;
  border-radius: 5px;

  &::-webkit-input-placeholder {
    color: #2d5566;
    padding-left: 0.25em;
  }
`;

const Input = styled.input`
  color: #707070;
  padding: 10px;
  width: 233px;
  font-family: Manrope, serif;
  border: 1px solid ${({ validation }) => (validation ? "#dcdcdc" : "red")};
  border-radius: 5px;
  //margin: 0 20px;

  &::-webkit-input-placeholder {
    padding-left: 0.25em;
  }
`;

const Section = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
`;

const ImagesWrapper = styled.div`
  align-items: start;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 0 30px;
`;

const InputSection = styled.div`
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  align-items: center;
`;
const GreyArea = styled.div`
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f4f4;
  padding: 20px 120px;
  border-radius: 17px;
  margin-top: 45px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
`;

const Title = styled.p`
  //text-transform: uppercase;
  margin-bottom: 10px;
  color: ${({ color = "#4b4b4b" }) => color};
  font-size: ${({ fontSize = 50 }) => fontSize}px;
  white-space: pre-wrap;
  text-align: center;
  font-family: Manrope, serif;
`;
export { WizardUnitStep1 };

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    "&:focus": {
      outline: 0,
    },
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: "none",
  },
}));
